import { css } from '@lit/reactive-element';
import { theme } from './theme';

export function isHTMLElement(node: Node | ChildNode): node is HTMLElement {
  return node.nodeType === 1;
}

export function waitMs(ms: number) {
  return new Promise((res) => setTimeout(res, ms));
}
export const isMac = window.navigator.userAgent.toLocaleLowerCase().includes('mac');

// from camelCase to kebab-case
export function toKebabCase(s: string): string {
  let kebab = '';
  for (const c of s) {
    const low = c.toLowerCase();
    const isLow = c === low;
    const isFirst = kebab.length === 0;
    kebab += `${isFirst || isLow ? '' : '-'}${low}`;
  }
  return kebab;
}

function capitalizeFirstLetter(s: string): string {
  const first = s.substr(0, 1).toUpperCase();
  const rest = s.substr(1).toLowerCase();
  return `${first}${rest}`;
}

// from kebab-case to camelCase
export function toCamelCase(s: string, firstCap = false): string {
  return s
    .split('-')
    .map((w, i) => (!firstCap && i === 0 ? w.toLowerCase() : capitalizeFirstLetter(w)))
    .join('');
}

export const getGlobalScrollbarCss = () => {
  if (isMac) return css``;

  return css`
    * {
      scrollbar-width: thin !important;
      scrollbar-color: ${theme.colors.shade3} !important;
    }

    *::-webkit-scrollbar-track {
      background-color: ${theme.colors.shade1} !important;
    }

    *::-webkit-scrollbar {
      width: 8px !important;
      height: 8px !important;
      background-color: ${theme.colors.shade1} !important;
    }

    *::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.shade3} !important;
    }
  `;
};

export const createBodyAnchor = (anchorName: string) => {
  if (document.getElementById(anchorName)) return;
  const anchor = document.createElement('div');
  anchor.style.zIndex = '9999';
  anchor.style.position = 'fixed';
  anchor.style.top = '0';
  anchor.style.left = '0';
  anchor.style.width = '100vw';
  anchor.style.height = '100vh';
  anchor.style.pointerEvents = 'none';
  anchor.id = anchorName;
  document.body.appendChild(anchor);
};

export const checkAndUpdateParentPosition = (parent: HTMLElement | null) => {
  if (!parent) return;

  const parentShadowNodes = parent.shadowRoot?.childNodes;

  if (!parent.style.position) {
    parent.style.position = 'relative';
  }

  parentShadowNodes?.forEach((node) => {
    if (isHTMLElement(node) && !node.style.position) {
      node.style.position = 'relative';
    }
  });
};
